import styled from "@emotion/styled";
import React from "react";
import { useLocation } from "react-router-dom";
import { mediaQuery } from "src/common";
import { AppRoutesAdditional } from "src/pages/app/_router/app.routes";
import { baseWidths, colors, footer } from "src/theme";

const ContentStyle = styled.div<{ $paddingTopPx: number }>(
  ({ $paddingTopPx }) => ({
    position: 'relative',
    paddingTop: `${$paddingTopPx}px`,
    backgroundColor: colors.background6,
    minHeight: `calc(100vh - ${footer.mobileHeight}px)`,
    overflowX: 'hidden',
    maxWidth: '100%',

    [mediaQuery('mobile')]: {
      minHeight: `calc(100vh - ${footer.height}px)`,
    },
  }),
);

const ContainerStyle = styled.div<{ shouldBeFullWidth: boolean }>(({ shouldBeFullWidth }) => ({
  width: shouldBeFullWidth ? '100%' : '88%',
  maxWidth: '100%',
  margin: '0 auto',
  paddingBlock: '24px',
  boxSizing: 'border-box',

  [mediaQuery('mobile')]: {
    width: shouldBeFullWidth ? '100%' : `${baseWidths.mobile}px`,
  },

  [mediaQuery('laptopL')]: {
    paddingBlock: '40px',
  },
}))

interface ContentProps {
  children: React.JSX.Element | React.JSX.Element[];
  /** Distance from viewport top to bottom of fixed header (logo + optional HeaderData + progress strip). */
  paddingTopPx: number;
}

export const Content = ({ children, paddingTopPx }: ContentProps) => {
  const { pathname } = useLocation();
  const shouldBeFullWidth = pathname.includes(AppRoutesAdditional.AGENT_OFFERS_PREVIEW.fullPath);
  return (
    <ContentStyle $paddingTopPx={paddingTopPx}>
      <ContainerStyle shouldBeFullWidth={shouldBeFullWidth}>
        {children}
      </ContainerStyle>
    </ContentStyle>
  )
}
